module.exports = __webpack_public_path__ + "static/img/noDataImg.09a0acc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/noDataImg.png
// module id = A/Sy
// module chunks = 1